import React from 'react'
import { AddStepType } from '../../types/journey-nodes'
import { StepCategory, STEP_CATEGORIES, STEP_CONFIG, resolveDescription, resolveLabel } from '../../step-config'
import { CatalogItemType } from '@pushly/models/lib/enums/catalogs/catalog-item-type'
import './add-step-panel.scss'

// region AddStepPanel Component

interface IAddStepPanelProps {
    options: AddStepType[]
    onSelect: (stepType: AddStepType) => void
    itemType?: CatalogItemType
}

export const AddStepPanel = ({ options, onSelect, itemType }: IAddStepPanelProps) => {
    const groupedOptions = Object.values(StepCategory)
        .sort((a, b) => STEP_CATEGORIES[a].order - STEP_CATEGORIES[b].order)
        .map((category) => ({
            category,
            config: STEP_CATEGORIES[category],
            items: options.filter((opt) => {
                const config = STEP_CONFIG[opt]
                return config?.kind === 'user' && config.category === category
            }),
        }))
        .filter((group) => group.items.length > 0)

    return (
        <div className="add-step-panel" role="region" aria-label="Add Step">
            <div className="add-step-panel-header">Add Step</div>
            <div className="add-step-panel-content">
                {groupedOptions.map(({ category, config: categoryConfig, items }) => (
                    <div key={category} className="add-step-panel-category" role="group" aria-label={categoryConfig.label}>
                        <div className="add-step-panel-category-heading">{categoryConfig.label}</div>
                        {items.map((type) => {
                            const config = STEP_CONFIG[type]
                            if (config?.kind !== 'user') return null
                            return (
                                <button
                                    key={type}
                                    className="add-step-panel-option"
                                    onClick={() => onSelect(type)}
                                    aria-label={resolveLabel(config, itemType ?? CatalogItemType.PRODUCT)}
                                    type="button"
                                >
                                    <span className={`add-step-panel-option-icon ${categoryConfig.iconClass}`}>
                                        {config.icon}
                                    </span>
                                    <span className="add-step-panel-option-text">
                                        <span className="add-step-panel-option-label">{resolveLabel(config, itemType ?? CatalogItemType.PRODUCT)}</span>
                                        <span className="add-step-panel-option-description">
                                            {resolveDescription(config, itemType ?? CatalogItemType.PRODUCT)}
                                        </span>
                                    </span>
                                </button>
                            )
                        })}
                    </div>
                ))}
            </div>
        </div>
    )
}

// endregion
